var map = {
	"./voice1.aac": 4824,
	"./voice2.mp3": 900,
	"./voice3.mp3": 5451,
	"./voice4.m4a": 539,
	"./voice5.m4a": 2258,
	"./voice6.m4a": 3071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7354;